export const STRINGS = {
  en: {
    appName: "MARQOLIX NG",
    tagline: "Next-gen AI Market Maker",
    version: "v1.1.0",

    // Main navigation
    menuDashboard: "Dashboard",
    menuLiquidity: "Liquidity Marketplace",
    menuArbitrage: "Arbitrage Engine",

    // Worker status panel
    workerStatusTitle: "Worker Status",
    workerBotOffline: "BOT OFFLINE",
    workerUptime: "Uptime",
    workerLastHeartbeat: "Last Heartbeat",
    workerCyclesTotal: "Cycles Total",
    workerErrorsTotal: "Errors Total",
    workerInstanceId: "Instance ID",
    workerPid: "Worker PID",
    workerRestartCount: "Restart Count",
    workerAutoRestart: "Auto-Restart",
    workerDesiredState: "Desired State",
    workerLastRestart: "Last Restart",
    workerLastRestartReason: "Last Restart Reason",
    workerLastChangedBy: "Last Changed By",

    complianceWarmingUp: "WARMING UP",
    priceGuardTitle: "Price Guard (daily open)",
    priceGuardOpen: "Open",
    priceGuardSource: "Source",
    priceGuardPct: "Δ vs open",
    priceGuardAllowedSide: "Allowed side",
    priceGuardRate: "Correction rate",
    priceGuardMode: "Mode",
    priceGuardReason: "Reason",

    // Phase 4 — Price Guard config section (bilingual)
    pgSectionTitle: "Price Guard — Daily Limit ±3% (Dry-Run only)",
    pgSectionNote:
      "Enforces daily band ±3% with 0.1%/min correction rate and ±2.5% hysteresis. Dry-run only until GO from operator.",
    pgRefreshMeta: "Refresh exchange metadata",
    pgRefreshMetaOk: "Exchange metadata refreshed",
    pgRefreshMetaExchange: "Exchange",
    pgRefreshMetaSelect: "Select exchange…",
    pgFieldNotes: {
      price_guard_enabled: "Master switch — turn ON to activate the daily guard.",
      price_guard_dry_run: "TRUE = log intents only, never send real orders.",
      daily_price_limit_pct: "Max % move allowed above/below daily open (default 3.0).",
      adjustment_rate_pct_per_minute:
        "Max corrective drift per minute (default 0.1 %).",
      safety_buffer_pct:
        "Hysteresis buffer — bot exits corrective mode only inside ±(limit − buffer). Default 0.5 → strict ±2.5%.",
      daily_open_source:
        "Anchor: exchange_ticker (default) · manual · daily_kline (reserved).",
      daily_open_timezone: "IANA TZ label, e.g. UTC / Africa/Accra.",
      daily_open_reset_time: "Daily rotation time HH:MM (24h).",
      daily_open_max_age_hours:
        "If open data is older than this, orders fail-closed. Default 26h.",
      daily_open_manual_price:
        "Only used when source=manual. Otherwise ignored.",
      price_guard_exchanges: "Comma-sep list where guard applies (e.g. lbank,coinstore).",
      price_guard_pairs: "Comma-sep. Empty = all pairs.",
      cancel_repost_delay_ms: "Delay between cancel_all() and repost (ms).",
      exchange_meta_cache_ttl_s:
        "TTL cache for precision/tick/lot (Coinstore). Default 900s.",
      intention_registry_enabled:
        "Persistent order-intention registry (dedup, MongoDB). Recommended ON.",
      intention_window_sec:
        "Dedup window (s). Identical retries within this window collapse.",
      hysteresis_persist_enabled:
        "Persist hysteresis state (bot restart-safe).",
    },

    auditTitle: "Audit Log",
    auditExportCsv: "Export CSV",
    auditFilterAction: "Filter action",
    auditFilterUser: "Filter user",
    auditTimestamp: "Timestamp",
    auditUser: "User",
    auditAction: "Action",
    auditTarget: "Target",
    auditStatus: "Status",
    auditPayload: "Payload",
    auditEmpty: "No audit entries yet.",
    outlook: "Outlook",
    bullish: "BULLISH",
    bearish: "BEARISH",
    neutral: "NEUTRAL",

    capitalTitle: "AI Capital Allocator",
    capitalAdvisoryNote: "Advisory only — you confirm before any change.",
    capitalUsdtBalance: "USDT balance",
    capitalTokenBalance: "Token balance",
    capitalLayersRefresh: "Layers · Refresh",
    capitalFillRate: "Fill rate 24h",
    capitalCurrentSize: "Current size",
    capitalAiMax: "AI max suggestion",
    capitalProjectedVolume: "Projected daily volume",
    capitalOfTarget: "of target",
    capitalApply: "Apply suggestion",
    capitalApplied: "Order size updated",
    applying: "Applying…",
    loading: "Loading…",

    arbTitle: "Arbitrage Engine — CEX↔CEX",
    arbStart: "Start",
    arbStop: "Stop",
    arbKill: "KILL SWITCH",
    arbKillConfirm: "Engage KILL SWITCH? The engine will hard-stop and arb_enabled will be set to false. You must clear arb_kill_switch in Config Editor to restart.",
    arbStarted: "Arbitrage engine started",
    arbStopped: "Arbitrage engine stopped",
    arbKillEngaged: "Kill switch engaged",
    arbKpiCycles: "Cycles 24h",
    arbKpiExecuted: "Executed",
    arbKpiVolume: "Volume 24h",
    arbKpiCapital: "Capital engaged",
    arbKpiPnl: "Net P&L 24h",
    arbKpiErrors: "Errors 24h",
    arbLastOpp: "Last opportunity",
    arbBuyEx: "BUY ON",
    arbSellEx: "SELL ON",
    arbBuyPrice: "Buy",
    arbSellPrice: "Sell",
    arbSize: "Size $",
    arbNetPnl: "Net P&L",
    arbMode: "Mode",

    healthTitle: "Health Monitor",
    healthTotalPortfolio: "Total portfolio",
    healthEngineRunning: "Arbitrage engine running",
    healthEngineUptime: "Engine uptime",
    healthBotRunning: "Bot running",
    healthAlerts24h: "Alerts 24h",
    healthStatus: "Status",
    healthLatency: "Latency",
    healthLastSync: "Last sync",
    healthPortfolio: "Portfolio",
    healthMode: "Mode",
    healthError: "Error",

    anaTitle: "Arbitrage Analytics",
    anaDetected: "Detected",
    anaExecuted: "Executed",
    anaSuccessRate: "Success rate",
    anaTotalPnl: "Total P&L",
    anaTotalVolume: "Total volume",
    anaAvgExecMs: "Avg exec",
    anaCumPnl: "Cumulative P&L",
    anaVolPerHour: "Volume / hour",
    anaByExchange: "Profit by exchange",
    anaByPair: "Profit by pair",
    anaRejReasons: "Rejection reasons",
    anaRoiDaily: "ROI daily",
    anaRoiWeekly: "ROI weekly",
    anaRoiMonthly: "ROI monthly",
    anaFees: "Fees paid",
    anaAvgSlippage: "Avg slippage",

    usersTitle: "User Management",
    userNewBtn: "+ New user",
    userEmail: "Email",
    userName: "Name",
    userPassword: "Password",
    userRole: "Role",
    userCreated: "User created",
    userUpdated: "User updated",
    userDeleted: "User deleted",
    userDeleteConfirm: "Delete user {email}? This cannot be undone.",
    create: "Create",
    cancel: "Cancel",
    delete: "Delete",
    actions: "Actions",
    exchange: "Exchange",

    // Liquidity Rewards
    rewardsTitle: "Liquidity Rewards",
    rewardsSubtitle: "Track & reimburse third-party liquidity providers",
    rewardsProvidersTitle: "Liquidity Providers",
    rewardsAddProvider: "+ Add provider",
    rewardsLabel: "Label",
    rewardsWallet: "Wallet / Account",
    rewardsContact: "Contact",
    rewardsWeight: "Weight",
    rewardsActive: "Active",
    rewardsCurrentEpoch: "Current Epoch",
    rewardsExternalVolume: "External maker volume (USD)",
    rewardsFeePct: "Avg exchange fee %",
    rewardsRebatePct: "Rebate % of fees",
    rewardsGrossPool: "Gross fee pool",
    rewardsRebatePool: "Rebate pool",
    rewardsApproveEpoch: "Approve epoch",
    rewardsHistoryTitle: "Epoch history",
    rewardsPayoutsTitle: "Payouts",
    rewardsAnalytics: "Rewards Analytics",
    rewardsTotalPaid: "Total paid",
    rewardsPendingTotal: "Total pending",
    rewardsActiveProviders: "Active providers",
    rewardsMarkPaid: "Mark paid",
    rewardsTxRef: "Tx reference",
    rewardsStatusOpen: "open",
    rewardsStatusApproved: "approved",
    rewardsStatusPaid: "paid",
    rewardsStatusPending: "pending",
    rewardsTopProviders: "Top providers",
    rewardsEpochsCount: "Epochs tracked",
    rewardsSetVolume: "Set volume",
    rewardsEpochWindow: "Window",
    rewardsProviderCreated: "Provider created",
    rewardsProviderUpdated: "Provider updated",
    rewardsProviderDeleted: "Provider removed",
    rewardsVolumeUpdated: "External volume updated",
    rewardsEpochApproved: "Epoch approved — payouts generated",
    rewardsPayoutMarked: "Payout marked as paid",
    rewardsDeleteProviderConfirm: "Remove provider {label}?",

    // Phase 3 UI — Diagnostics + API Audit Log + Enriched Wallets
    diagTitle: "Exchange Diagnostics",
    diagSubtitle: "Run a full API connection test against each exchange",
    diagRunBtn: "Test API Connection",
    diagRunning: "Running…",
    diagOutboundIp: "Outbound IP",
    diagFixieHint: "Compare with your exchange API whitelist",
    diagClockDrift: "Clock drift",
    diagStepStatus: "Status",
    diagStepLatency: "Latency",
    diagStepCode: "Code",
    diagStepMessage: "Message",
    diagPass: "PASS",
    diagFail: "FAIL",
    diagDenied: "DENIED",
    diagPermissionsTitle: "Permissions",
    diagWalletsTitle: "Wallets",
    diagOrderbookTitle: "Order book",
    diagCrosscheckTitle: "Market data cross-check",
    diagOrderbookReason: "Reason",
    diagWalletAsset: "Asset",
    diagWalletAvailable: "Available",
    diagWalletFrozen: "Frozen",
    diagWalletTotal: "Total",
    diagWalletUsd: "USD value",
    diagWalletStatus: "Status",
    diagWalletLastSync: "Last sync",
    diagNoData: "No active exchanges",
    diagSelectExchange: "Select exchange",
    apiLogTitle: "API Audit Log",
    apiLogSubtitle: "Last 100 exchange API calls — filter, drill down, export",
    apiLogFilterExchange: "Exchange",
    apiLogFilterEndpoint: "Endpoint contains…",
    apiLogFilterStatus: "Status",
    apiLogFilterAll: "All",
    apiLogFilterOk: "Success only",
    apiLogFilterFail: "Failures only",
    apiLogColTs: "Time",
    apiLogColExchange: "Exchange",
    apiLogColEndpoint: "Endpoint",
    apiLogColMethod: "Method",
    apiLogColStatus: "Status",
    apiLogColLatency: "Latency",
    apiLogColExchCode: "Code",
    apiLogColExchMsg: "Message",
    apiLogExportCsv: "Export CSV",
    apiLogExportJson: "Export JSON",
    apiLogEmpty: "No API calls recorded yet.",
    apiLogRefresh: "Refresh",

    loginTitle: "Operator Access",
    loginSubtitle: "Authenticated terminal — Marqolix NG control plane",
    email: "Email",
    password: "Password",
    signIn: "Sign in",
    signingIn: "Authenticating…",
    invalidCreds: "Invalid email or password",

    botRunning: "Running",
    botStopped: "Stopped",
    botHalted: "Halted",
    start: "Start bot",
    stop: "Stop bot",
    emergencyStop: "Emergency stop",
    confirmEmergency: "Cancel ALL orders on every exchange?",

    mode: "Operating mode",
    marketMaker: "Market Maker",
    buyOnly: "Buy Only",
    sellOnly: "Sell Only",
    buyPct: "Buy at ≤% of ask",
    sellPct: "Sell at % of bid",

    metrics: "Metrics",
    spread: "Spread",
    depth: "Depth",
    volume24h: "24h Volume",
    target: "target",
    pnl: "Daily PnL",
    equity: "Equity",
    regime: "Regime",

    compliance: "Compliance — NG v1.1",
    rule1: "Spread < 1.5%",
    rule2: "Depth ±2% > $200",
    rule3: "Volume > $1500 / 24h",
    pass: "PASS",
    warn: "WARN",
    fail: "FAIL",

    orderBook: "Order book",
    bids: "Bids",
    asks: "Asks",
    fills: "Recent fills",
    side: "Side",
    price: "Price",
    qty: "Qty",
    usd: "USD",
    exchange: "Exchange",
    time: "Time",

    alerts: "Alert log",
    severity: "Severity",
    event: "Event",
    message: "Message",
    noAlerts: "No alerts yet",

    wallets: "Wallets",
    balance: "Balance",
    asset: "Asset",

    config: "Configuration",
    save: "Save config",
    saved: "Saved",
    saving: "Saving…",

    charts: "Charts",
    pnlOverTime: "PnL over time",
    spreadHistory: "Spread history",

    pair: "Trading pair",
    pairRequired: "Trading pair is required",
    logout: "Sign out",
    language: "Lang",

    exchangeHealth: "Exchange health",
    healthOk: "ONLINE",
    healthDown: "DEGRADED",

    aggressiveMode: "Aggressive spread mode active",
    noData: "No data",
    noActiveExchange: "No active exchange — enable one in the Config Editor.",
    exchangesLower: "exchanges",
    openOrders: "Open orders",
    recentFills: "Recent executions",
    noOpenOrders: "No open orders",

    // iter36 — adaptive sizing panel
    adaptivePanelTitle: "Adaptive Sizing & Effective Risk",
    apRiskCap: "USD cap",
    apRiskPct: "% of equity",
    apEffectiveLoss: "Effective daily loss",
    apStartingEquity: "Starting equity",
    apCurrentEquity: "Current equity",
    apDailyPnl: "Daily PnL",
    apBaselineTs: "Baseline",
    apEquityUnavail: "Price feed",
    apPriceSources: "Price sources",
    apPerExchange: "Per-exchange sizing",
    apRegime: "Regime",
    apLayers: "Layers",
    apPerLayer: "$ / layer",
    apDeploy: "Deploy",
    apUtil: "Util",
    apStatus: "Status",

    confirmStop: "Stop the bot? Open orders will be cancelled.",
  },
  fr: {
    appName: "MARQOLIX NG",
    tagline: "Market Maker IA nouvelle génération",
    version: "v1.1.0",

    // Navigation principale
    menuDashboard: "Tableau de bord",
    menuLiquidity: "Liquidity Marketplace",
    menuArbitrage: "Arbitrage Engine",

    // Worker status panel
    workerStatusTitle: "État du moteur",
    workerBotOffline: "BOT HORS-LIGNE",
    workerUptime: "Durée de fonctionnement",
    workerLastHeartbeat: "Dernier battement",
    workerCyclesTotal: "Cycles totaux",
    workerErrorsTotal: "Erreurs totales",
    workerInstanceId: "ID d'instance",
    workerPid: "PID du worker",
    workerRestartCount: "Redémarrages",
    workerAutoRestart: "Auto-redémarrage",
    workerDesiredState: "État voulu",
    workerLastRestart: "Dernier redémarrage",
    workerLastRestartReason: "Raison du redémarrage",
    workerLastChangedBy: "Modifié par",

    complianceWarmingUp: "EN CHAUFFE",
    priceGuardTitle: "Price Guard (ouverture quotidienne)",
    priceGuardOpen: "Ouverture",
    priceGuardSource: "Source",
    priceGuardPct: "Δ vs ouverture",
    priceGuardAllowedSide: "Côté autorisé",
    priceGuardRate: "Vitesse correction",
    priceGuardMode: "Mode",
    priceGuardReason: "Motif",

    // Phase 4 — Price Guard config section (bilingue)
    pgSectionTitle: "Price Guard — Limite journalière ±3% (Dry-Run uniquement)",
    pgSectionNote:
      "Applique une bande journalière ±3% avec correction 0,1%/min et hystérésis ±2,5%. Dry-run tant que l'opérateur n'a pas donné le GO.",
    pgRefreshMeta: "Rafraîchir les métadonnées de l'exchange",
    pgRefreshMetaOk: "Métadonnées de l'exchange rafraîchies",
    pgRefreshMetaExchange: "Exchange",
    pgRefreshMetaSelect: "Choisir un exchange…",
    pgFieldNotes: {
      price_guard_enabled:
        "Interrupteur principal — ON pour activer la garde quotidienne.",
      price_guard_dry_run:
        "TRUE = journaliser les intentions sans envoyer d'ordre réel.",
      daily_price_limit_pct:
        "% max autorisé au-dessus/dessous de l'ouverture du jour (défaut 3,0).",
      adjustment_rate_pct_per_minute:
        "Dérive corrective max par minute (défaut 0,1 %).",
      safety_buffer_pct:
        "Hystérésis — le bot sort du mode correctif seulement dans ±(limite − buffer). Défaut 0,5 → strict ±2,5%.",
      daily_open_source:
        "Ancrage : exchange_ticker (défaut) · manual · daily_kline (réservé).",
      daily_open_timezone: "Fuseau IANA, ex. UTC / Africa/Accra.",
      daily_open_reset_time: "Heure de bascule quotidienne HH:MM (24h).",
      daily_open_max_age_hours:
        "Si l'ouverture est plus ancienne, les ordres passent en fail-closed. Défaut 26h.",
      daily_open_manual_price:
        "Utilisé seulement quand source=manual. Sinon ignoré.",
      price_guard_exchanges:
        "Liste séparée par virgules (ex. lbank,coinstore).",
      price_guard_pairs: "CSV. Vide = toutes les paires.",
      cancel_repost_delay_ms:
        "Délai entre cancel_all() et repost (ms).",
      exchange_meta_cache_ttl_s:
        "TTL cache précisions/tick/lot (Coinstore). Défaut 900s.",
      intention_registry_enabled:
        "Registre d'intentions persistant (dédup MongoDB). Recommandé ON.",
      intention_window_sec:
        "Fenêtre dédup (s). Les retries identiques dans la fenêtre fusionnent.",
      hysteresis_persist_enabled:
        "Persister l'état d'hystérésis (résilient aux redémarrages).",
    },

    auditTitle: "Journal d'audit",
    auditExportCsv: "Exporter CSV",
    auditFilterAction: "Filtrer action",
    auditFilterUser: "Filtrer utilisateur",
    auditTimestamp: "Horodatage",
    auditUser: "Utilisateur",
    auditAction: "Action",
    auditTarget: "Cible",
    auditStatus: "Statut",
    auditPayload: "Détails",
    auditEmpty: "Aucune entrée d'audit pour l'instant.",
    outlook: "Tendance",
    bullish: "HAUSSIER",
    bearish: "BAISSIER",
    neutral: "NEUTRE",

    capitalTitle: "Allocateur de capital IA",
    capitalAdvisoryNote: "Conseil uniquement — vous confirmez avant tout changement.",
    capitalUsdtBalance: "Solde USDT",
    capitalTokenBalance: "Solde Token",
    capitalLayersRefresh: "Couches · Refresh",
    capitalFillRate: "Taux fill 24h",
    capitalCurrentSize: "Taille actuelle",
    capitalAiMax: "Suggestion max IA",
    capitalProjectedVolume: "Volume projeté/jour",
    capitalOfTarget: "de l'objectif",
    capitalApply: "Appliquer la suggestion",
    capitalApplied: "Taille des ordres mise à jour",
    applying: "Application…",
    loading: "Chargement…",

    arbTitle: "Moteur d'arbitrage — CEX↔CEX",
    arbStart: "Démarrer",
    arbStop: "Arrêter",
    arbKill: "ARRÊT D'URGENCE",
    arbKillConfirm: "Engager l'ARRÊT D'URGENCE ? Le moteur s'arrête et arb_enabled passe à false. Vous devrez désactiver arb_kill_switch dans Config Editor pour relancer.",
    arbStarted: "Moteur d'arbitrage démarré",
    arbStopped: "Moteur d'arbitrage arrêté",
    arbKillEngaged: "Arrêt d'urgence engagé",
    arbKpiCycles: "Cycles 24h",
    arbKpiExecuted: "Exécutés",
    arbKpiVolume: "Volume 24h",
    arbKpiCapital: "Capital engagé",
    arbKpiPnl: "P&L net 24h",
    arbKpiErrors: "Erreurs 24h",
    arbLastOpp: "Dernière opportunité",
    arbBuyEx: "ACHAT SUR",
    arbSellEx: "VENTE SUR",
    arbBuyPrice: "Achat",
    arbSellPrice: "Vente",
    arbSize: "Taille $",
    arbNetPnl: "P&L net",
    arbMode: "Mode",

    healthTitle: "Centre de surveillance",
    healthTotalPortfolio: "Portefeuille total",
    healthEngineRunning: "Arbitrage engine actif",
    healthEngineUptime: "Uptime moteur",
    healthBotRunning: "Bot actif",
    healthAlerts24h: "Alertes 24h",
    healthStatus: "Statut",
    healthLatency: "Latence",
    healthLastSync: "Dernière sync",
    healthPortfolio: "Portefeuille",
    healthMode: "Mode",
    healthError: "Erreur",

    anaTitle: "Analytics Arbitrage",
    anaDetected: "Détectées",
    anaExecuted: "Exécutées",
    anaSuccessRate: "Taux de succès",
    anaTotalPnl: "P&L total",
    anaTotalVolume: "Volume total",
    anaAvgExecMs: "Exec moy.",
    anaCumPnl: "P&L cumulé",
    anaVolPerHour: "Volume / heure",
    anaByExchange: "Profit par exchange",
    anaByPair: "Profit par paire",
    anaRejReasons: "Raisons de rejet",
    anaRoiDaily: "ROI journalier",
    anaRoiWeekly: "ROI hebdo",
    anaRoiMonthly: "ROI mensuel",
    anaFees: "Frais payés",
    anaAvgSlippage: "Slippage moy.",

    usersTitle: "Gestion des utilisateurs",
    userNewBtn: "+ Nouvel utilisateur",
    userEmail: "Email",
    userName: "Nom",
    userPassword: "Mot de passe",
    userRole: "Rôle",
    userCreated: "Utilisateur créé",
    userUpdated: "Utilisateur mis à jour",
    userDeleted: "Utilisateur supprimé",
    userDeleteConfirm: "Supprimer l'utilisateur {email} ? Action irréversible.",
    create: "Créer",
    cancel: "Annuler",
    delete: "Supprimer",
    actions: "Actions",
    exchange: "Exchange",

    // Liquidity Rewards
    rewardsTitle: "Récompenses de liquidité",
    rewardsSubtitle: "Suivre & rémunérer les fournisseurs de liquidité tiers",
    rewardsProvidersTitle: "Fournisseurs de liquidité",
    rewardsAddProvider: "+ Ajouter un LP",
    rewardsLabel: "Libellé",
    rewardsWallet: "Portefeuille / Compte",
    rewardsContact: "Contact",
    rewardsWeight: "Poids",
    rewardsActive: "Actif",
    rewardsCurrentEpoch: "Période courante",
    rewardsExternalVolume: "Volume maker externe (USD)",
    rewardsFeePct: "Frais exchange moyens %",
    rewardsRebatePct: "% des frais rétrocédés",
    rewardsGrossPool: "Pool de frais brut",
    rewardsRebatePool: "Pool de rétro-com.",
    rewardsApproveEpoch: "Approuver la période",
    rewardsHistoryTitle: "Historique des périodes",
    rewardsPayoutsTitle: "Versements",
    rewardsAnalytics: "Analytique Rewards",
    rewardsTotalPaid: "Total payé",
    rewardsPendingTotal: "Total en attente",
    rewardsActiveProviders: "LPs actifs",
    rewardsMarkPaid: "Marquer payé",
    rewardsTxRef: "Référence tx",
    rewardsStatusOpen: "ouverte",
    rewardsStatusApproved: "approuvée",
    rewardsStatusPaid: "payée",
    rewardsStatusPending: "en attente",
    rewardsTopProviders: "Top fournisseurs",
    rewardsEpochsCount: "Périodes suivies",
    rewardsSetVolume: "Enregistrer volume",
    rewardsEpochWindow: "Fenêtre",
    rewardsProviderCreated: "Fournisseur créé",
    rewardsProviderUpdated: "Fournisseur mis à jour",
    rewardsProviderDeleted: "Fournisseur supprimé",
    rewardsVolumeUpdated: "Volume externe mis à jour",
    rewardsEpochApproved: "Période approuvée — versements générés",
    rewardsPayoutMarked: "Versement marqué payé",
    rewardsDeleteProviderConfirm: "Supprimer le fournisseur {label} ?",

    // Phase 3 UI — Diagnostics + API Audit Log + Enriched Wallets
    diagTitle: "Diagnostic Exchanges",
    diagSubtitle: "Lancer un test API complet pour chaque exchange",
    diagRunBtn: "Tester la connexion API",
    diagRunning: "Exécution…",
    diagOutboundIp: "IP sortante",
    diagFixieHint: "À comparer avec la whitelist API exchange",
    diagClockDrift: "Décalage horloge",
    diagStepStatus: "Statut",
    diagStepLatency: "Latence",
    diagStepCode: "Code",
    diagStepMessage: "Message",
    diagPass: "PASS",
    diagFail: "FAIL",
    diagDenied: "REFUSÉ",
    diagPermissionsTitle: "Permissions",
    diagWalletsTitle: "Wallets",
    diagOrderbookTitle: "Carnet d'ordres",
    diagCrosscheckTitle: "Cross-check données marché",
    diagOrderbookReason: "Raison",
    diagWalletAsset: "Actif",
    diagWalletAvailable: "Disponible",
    diagWalletFrozen: "Gelé",
    diagWalletTotal: "Total",
    diagWalletUsd: "Valeur USD",
    diagWalletStatus: "Statut",
    diagWalletLastSync: "Dernière synchro",
    diagNoData: "Aucun exchange actif",
    diagSelectExchange: "Choisir exchange",
    apiLogTitle: "Journal API Audit",
    apiLogSubtitle: "100 derniers appels API exchange — filtrer, inspecter, exporter",
    apiLogFilterExchange: "Exchange",
    apiLogFilterEndpoint: "Endpoint contient…",
    apiLogFilterStatus: "Statut",
    apiLogFilterAll: "Tous",
    apiLogFilterOk: "Succès uniquement",
    apiLogFilterFail: "Échecs uniquement",
    apiLogColTs: "Heure",
    apiLogColExchange: "Exchange",
    apiLogColEndpoint: "Endpoint",
    apiLogColMethod: "Méthode",
    apiLogColStatus: "Statut",
    apiLogColLatency: "Latence",
    apiLogColExchCode: "Code",
    apiLogColExchMsg: "Message",
    apiLogExportCsv: "Export CSV",
    apiLogExportJson: "Export JSON",
    apiLogEmpty: "Aucun appel API enregistré.",
    apiLogRefresh: "Rafraîchir",

    loginTitle: "Accès Opérateur",
    loginSubtitle: "Terminal sécurisé — plan de contrôle Marqolix NG",
    email: "E-mail",
    password: "Mot de passe",
    signIn: "Connexion",
    signingIn: "Authentification…",
    invalidCreds: "E-mail ou mot de passe invalide",

    botRunning: "En marche",
    botStopped: "Arrêté",
    botHalted: "Bloqué",
    start: "Démarrer le bot",
    stop: "Arrêter le bot",
    emergencyStop: "Arrêt d'urgence",
    confirmEmergency: "Annuler TOUS les ordres sur toutes les bourses ?",

    mode: "Mode d'opération",
    marketMaker: "Market Maker",
    buyOnly: "Achat seul",
    sellOnly: "Vente seule",
    buyPct: "Achat à ≤% du ask",
    sellPct: "Vente à % du bid",

    metrics: "Métriques",
    spread: "Spread",
    depth: "Profondeur",
    volume24h: "Volume 24h",
    target: "objectif",
    pnl: "PnL jour",
    equity: "Capital",
    regime: "Régime",

    compliance: "Conformité — NG v1.1",
    rule1: "Spread < 1,5%",
    rule2: "Profondeur ±2% > 200 $",
    rule3: "Volume > 1500 $ / 24h",
    pass: "OK",
    warn: "ALERTE",
    fail: "ÉCHEC",

    orderBook: "Carnet d'ordres",
    bids: "Achats",
    asks: "Ventes",
    fills: "Exécutions récentes",
    side: "Sens",
    price: "Prix",
    qty: "Qté",
    usd: "USD",
    exchange: "Bourse",
    time: "Heure",

    alerts: "Journal d'alertes",
    severity: "Gravité",
    event: "Évènement",
    message: "Message",
    noAlerts: "Aucune alerte",

    wallets: "Portefeuilles",
    balance: "Solde",
    asset: "Actif",

    config: "Configuration",
    save: "Enregistrer",
    saved: "Enregistré",
    saving: "Enregistrement…",

    charts: "Graphiques",
    pnlOverTime: "PnL dans le temps",
    spreadHistory: "Historique du spread",

    pair: "Paire de trading",
    pairRequired: "La paire de trading est requise",
    logout: "Déconnexion",
    language: "Lang",

    exchangeHealth: "État bourse",
    healthOk: "EN LIGNE",
    healthDown: "DÉGRADÉE",

    aggressiveMode: "Mode spread agressif actif",
    noData: "Aucune donnée",
    noActiveExchange: "Aucun exchange actif — activez-en un dans le Config Editor.",
    exchangesLower: "exchanges",
    openOrders: "Ordres ouverts",
    recentFills: "Exécutions récentes",
    noOpenOrders: "Aucun ordre ouvert",

    // iter36 — panel sizing adaptatif
    adaptivePanelTitle: "Sizing adaptatif & Risque effectif",
    apRiskCap: "Plafond USD",
    apRiskPct: "% d'équité",
    apEffectiveLoss: "Perte journ. effective",
    apStartingEquity: "Équité initiale",
    apCurrentEquity: "Équité courante",
    apDailyPnl: "PnL journalier",
    apBaselineTs: "Baseline",
    apEquityUnavail: "Flux de prix",
    apPriceSources: "Sources de prix",
    apPerExchange: "Sizing par exchange",
    apRegime: "Régime",
    apLayers: "Layers",
    apPerLayer: "$ / layer",
    apDeploy: "Déployé",
    apUtil: "Util",
    apStatus: "Statut",

    confirmStop: "Arrêter le bot ? Les ordres ouverts seront annulés.",
  },
};
